// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_MoVHI","bc":"index_bc_zCuUU","main":"index_main_a9EAl"};